let HandleGtag = {
  methods: {
    gtag: function () {
      if (window.dataLayer) {
        window.dataLayer.push(arguments);
      } else {
        console.log('local gtag');
        console.log(arguments);
      }
    }
  },
};

export default HandleGtag;
